import axios from 'axios'
import { axiosConfig } from '@/config/axiosConfig.js'

export const  get_customized_information_ajax = async (client_name, parameters = '') => {
    try {
        const res = await axios.get(`${client_name}/webmap/get_customization_bulletin/?${parameters}`, axiosConfig)
        return res.data.data.map(datum => {
            return {
                data_source: 'customized',
                title: datum.subject,
                content: datum.text
            }
        });
    } catch (e) {
        console.error(e);
    }
}